import React from 'react';
import { Typography, Card, Alert, Button } from 'antd';
import { ProjectOutlined } from '@ant-design/icons';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph } = Typography;

export default function PlasmidConstructionPage() {
  const navigate = useNavigate();
  return (
      <div style={{ maxWidth: 1000, margin: '0 auto' }}>
        <Button 
          icon={<ArrowLeftOutlined />} 
          onClick={() => navigate('/cloning')}
          style={{ marginBottom: 16 }}
        >
          返回分子克隆
        </Button>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <ProjectOutlined style={{ fontSize: '64px', color: '#fa8c16', marginBottom: 16 }} />
          <Title level={2}>质粒构建绘图</Title>
          <Paragraph style={{ fontSize: '16px', color: '#666' }}>
            质粒图谱绘制、基因插入位置标注、载体特征显示等功能
          </Paragraph>
        </div>

        <Alert
          message="功能开发中"
          description="质粒构建绘图功能正在开发中，敬请期待。将提供质粒图谱绘制、基因插入标注、载体特征显示、序列导出等功能。"
          type="info"
          showIcon
          style={{ marginBottom: 24 }}
        />

        <Card title="计划功能" style={{ marginBottom: 24 }}>
          <ul style={{ paddingLeft: 20 }}>
            <li style={{ marginBottom: 8 }}>质粒图谱绘制 - 生成圆形或线性质粒图谱</li>
            <li style={{ marginBottom: 8 }}>基因插入标注 - 标注目的基因插入位置和方向</li>
            <li style={{ marginBottom: 8 }}>载体特征显示 - 显示启动子、终止子、抗性基因等特征</li>
            <li style={{ marginBottom: 8 }}>序列导出 - 导出完整质粒序列文件</li>
            <li style={{ marginBottom: 8 }}>多格式支持 - 支持GenBank、FASTA等多种格式</li>
            <li style={{ marginBottom: 8 }}>自定义标注 - 支持用户自定义特征标注</li>
          </ul>
        </Card>
      </div>
  );
}
